(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairTotalStudentsController', PhysicalFairTotalStudentsController);
    PhysicalFairTotalStudentsController.$inject = ['PhysicalFairService', 'ExpoService', 'CitiesByExpoService', '$uibModal', 'isPlatformRental'];

    function PhysicalFairTotalStudentsController(PhysicalFairService, ExpoService, CitiesByExpoService, $uibModal, isPlatformRental) {
        var vm = this;
        vm.flag                    = false;
        vm.gpData                  = [];
        vm.isThereCity             = false;
        vm.expoSelected            = [];
        vm.citySelected            = '';
        vm.typeSelected            = [{name:'All', id:-1}];
        vm.types                   = [{name:'All', id:-1},{name:'Attended', id:1},{name:'Not Attended', id:0}];
        vm.result                  = [];
        vm.expo                    = [];
        vm.physicalFairSelected    = [];
        vm.getByFilter             = getByFilter;
        vm.getAllPhysicalFair      = getAllPhysicalFair;
        //vm.selectExpo              = selectExpo;
        vm.selectCitiesByExpo      = selectCitiesByExpo;
        vm.isPlatformRental        = isPlatformRental;
        vm.downloadCSV             = downloadCSV;

        /*PAGINATION*/
        vm.pageChanged           = pageChanged;
        vm.setPage               = setPage;
        vm.to                    = [];
        vm.totalItems            = [];
        vm.currentPage           = null;
        vm.itemsPerPage          = [];
        vm.page                  = 1;

        function active() {
            vm.getAllPhysicalFair();
        }

        function getByFilter() {
            var query = [];
            vm.flag = false;
            query['expo_id'] = vm.expoSelected.id;
            query['coefficient'] = vm.expoSelected.reports_coefficient;
            if(typeof vm.citySelected !== 'undefined' && vm.citySelected.id !== -1) {
                query['city_id']    = vm.citySelected.id;
                query['city_alias'] = vm.citySelected.alias;
            }

            if(vm.typeSelected != -1) {
                query['type'] = vm.typeSelected;
            }
            PhysicalFairService.getByTotalStudents(query).then(function(response) {
                vm.flag = true;
                vm.result = response.data;
                vm.gpData = response.data;
                vm.isThereCity = (typeof vm.citySelected.id !== 'undefined' && vm.citySelected.id !== -1 && vm.citySelected !== []);
            }).catch(function(err) {
            });
        }

        // function selectExpo () {
        //     ExpoService.getExpos().then(function(response){
        //         vm.expo = response.data;
        //     }).catch(function(err) {
        //     });
        // }

        function selectCitiesByExpo () {
            var params = [];
            vm.city = [];
            params['expo_id']  = vm.expoSelected.id;
            vm.citySelected = [];
            CitiesByExpoService.getCities(params['expo_id']).then(function(response){
                vm.city = response.data;
                vm.city.unshift({id:-1,city_name:"All"});
            }).catch(function(err) {
            });
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function getAllPhysicalFair() {
            var query = [];
            if(vm.isPlatformRental) {
                query['platform-rental'] = 1;
            }
            PhysicalFairService.getExpos(query).then(function(response) {
                vm.expo = response.data;
            }).catch(function(err) {
            });
        }
        
        function downloadCSV() {
            vm.disableDownloadCsv = true;

            let query = {};

            query['expo_id'] = vm.expoSelected.id;
            query['expo_city_id'] = vm.citySelected.id;

            if(vm.isPlatformRental) {
                query['platform-rental'] = 1;
            }

            if(vm.typeSelected != -1) {
                query['type'] = vm.typeSelected;
            }

            PhysicalFairService.leadsCSV(vm.expoSelected.id, query).success(function (data) {
              var anchor = document.createElement("a");
              anchor.href = "data:application/octet-stream;base64," + encodeURI(data);
              anchor.target = "_blank";
              anchor.download = `physical_fair_leads_${vm.expoSelected.id}.csv`;
              document.body.appendChild(anchor);
              anchor.click();
              vm.disableDownloadCsv = false;
              $timeout(function () {
                anchor.remove();
              }, 50);
            });
        }

        active();
    }
})();